// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = (acct) => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      console.log("account: ", acct);
      let totalSupply = await store
        .getState()
        .blockchain.smartContract.methods.totalSupply()
        .call();
      let isWhitelistedBool = await store
        .getState()
        .blockchain.smartContract.methods.isWhitelisted(acct)
        .call();
        console.log("wl: ", isWhitelistedBool);
      let addressMintedCnt = await store
        .getState()
        .blockchain.smartContract.methods.addressMintedBalance(acct)
        .call();
      let feeresponse = await fetch('https://gasstation-mainnet.matic.network/v2')
      let feeJSON = await feeresponse.json()
      console.log(feeJSON);
      // let cost = await store
      //   .getState()
      //   .blockchain.smartContract.methods.cost()
      //   .call();

      dispatch(
        fetchDataSuccess({
          totalSupply,
          isWhitelistedBool,
          addressMintedCnt,
          feeJSON
          // cost,
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
